import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import styles from "./Sidebar.module.css";
import xIcon from "../../Img/header/xIcon.png";
import xIconWhite from "../../Img/header/xIcon_white.png";
import { Link, useLocation } from "react-router-dom";
const Sidebar = ({
  width,
  children,
  xPosition,
  side,
  isOpen,
  setOpen,
  setX,
  logo,
  onClose,
  onClick,
  isDarkMode,
  select,
}) => {
  const location = useLocation();
  const handleClose = async (e) => {
    let sideArea = side.current;
    let sideCildren = side.current.contains(e.target);
    if (isOpen && (!sideArea || !sideCildren)) {
      await setX(-width);
      await setOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener("click", handleClose);
    return () => {
      window.removeEventListener("click", handleClose);
    };
  });

  return (
    <div className={styles.container}>
      <div className={styles.sideContainer}>
        <div
          ref={side}
          className={!isDarkMode ? styles.sidebar : styles.dark_sidebar}
        >
          <div className={!isDarkMode ? styles.content : styles.dark_mode}>
            <div className={styles.logoBox}>
              <img
                src={!isDarkMode ? xIcon : xIconWhite}
                alt=""
                onClick={onClose}
                className={!isDarkMode ? styles.xIcon : styles.dark_xIcon}
              />
              <div className={styles.logo}>
                <img src={logo} alt="" />
                <div>CAREERS</div>
              </div>
            </div>
            <div className={styles.menuList}>
              {!isDarkMode && (
                <>
                  <Link
                    to="/"
                    onClick={onClick}
                    className={classNames(
                      select("메인") || location.pathname === "/"
                        ? styles.activeMenu
                        : styles.inactiveMenu
                    )}
                  >
                    메인
                  </Link>
                  <Link
                    to="/culture"
                    onClick={onClick}
                    className={classNames(
                      select("문화와 비전") || location.pathname === "/culture"
                        ? styles.activeMenu
                        : styles.inactiveMenu
                    )}
                  >
                    문화와 복지
                  </Link>
                  <Link
                    to="/position"
                    onClick={onClick}
                    className={classNames(
                      select("채용 중인 직무") ||
                        location.pathname.split("/")[1].includes("position")
                        ? styles.activeMenu
                        : styles.inactiveMenu
                    )}
                  >
                    채용 중인 직무
                  </Link>
                  {/* <Link
                    to="/faq"
                    onClick={onClick}
                    className={classNames(
                      select("자주 묻는 질문") || location.pathname === "/faq"
                        ? styles.activeMenu
                        : styles.inactiveMenu
                    )}
                  >
                    자주 묻는 질문
                  </Link> */}
                </>
              )}
              {isDarkMode && (
                <>
                  <Link
                    to="/"
                    onClick={onClick}
                    className={classNames(
                      select("메인") || location.pathname === "/"
                        ? styles.DarkActiveMenu
                        : styles.DarkInactiveMenu
                    )}
                  >
                    메인
                  </Link>
                  <Link
                    to="/culture"
                    onClick={onClick}
                    className={classNames(
                      select("문화와 비전") || location.pathname === "/culture"
                        ? styles.DarkActiveMenu
                        : styles.DarkInactiveMenu
                    )}
                  >
                    문화와 복지
                  </Link>
                  <Link
                    to="/position"
                    onClick={onClick}
                    className={classNames(
                      select("채용 중인 직무") ||
                        location.pathname.split("/")[1].includes("position")
                        ? styles.DarkActiveMenu
                        : styles.DarkInactiveMenu
                    )}
                  >
                    채용 중인 직무
                  </Link>
                  {/* <Link
                    to="/faq"
                    onClick={onClick}
                    className={classNames(
                      select("자주 묻는 질문") || location.pathname === "/faq"
                        ? styles.DarkActiveMenu
                        : styles.DarkInactiveMenu
                    )}
                  >
                    자주 묻는 질문
                  </Link> */}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
